var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7075 18.292C19.8004 18.3849 19.8741 18.4952 19.9244 18.6166C19.9747 18.738 20.0006 18.8681 20.0006 18.9995C20.0006 19.1309 19.9747 19.261 19.9244 19.3824C19.8741 19.5037 19.8004 19.614 19.7075 19.707C19.6146 19.7999 19.5043 19.8736 19.3829 19.9239C19.2615 19.9741 19.1314 20 19 20C18.8686 20 18.7385 19.9741 18.6171 19.9239C18.4957 19.8736 18.3854 19.7999 18.2925 19.707L10 11.4132L1.70751 19.707C1.51987 19.8946 1.26537 20 1.00001 20C0.734643 20 0.480147 19.8946 0.292507 19.707C0.104866 19.5193 -0.000549311 19.2648 -0.000549316 18.9995C-0.000549322 18.7341 0.104866 18.4796 0.292507 18.292L8.58626 9.99946L0.292507 1.70696C0.104866 1.51932 -0.000549316 1.26482 -0.000549316 0.999457C-0.000549316 0.734093 0.104866 0.479598 0.292507 0.291957C0.480147 0.104317 0.734643 -0.00109863 1.00001 -0.00109863C1.26537 -0.00109863 1.51987 0.104317 1.70751 0.291957L10 8.58571L18.2925 0.291957C18.4801 0.104317 18.7346 -0.00109864 19 -0.00109863C19.2654 -0.00109863 19.5199 0.104317 19.7075 0.291957C19.8951 0.479598 20.0006 0.734093 20.0006 0.999457C20.0006 1.26482 19.8951 1.51932 19.7075 1.70696L11.4138 9.99946L19.7075 18.292Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.e798d63f4581aa4b4ccf72e9a02ed47e.svg";
export { ForwardRef as ReactComponent };